<button mat-icon-button class="change-avatar-dialog__close" (click)="matDialogRef.close()">
  <mat-icon>close</mat-icon>
</button>

<div *ngIf="changeAvatarInput" class="change-avatar-dialog__content">
  <p class="change-avatar-dialog__content_title">
    {{ 'CHANGE_AVATAR.TITLE' | translate }}
  </p>

  <input #fileInput type="file" hidden accept="image/*" (change)="addFileToInput($event)" />

  <div
    *ngIf="changeAvatarInput.invalid"
    #uploadField
    role="button"
    class="change-avatar-dialog__content__upload"
    matRipple
    (click)="fileInput.click()"
    dropzone="copy"
    (dragover)="$event.preventDefault(); uploadField.classList.add('change-avatar-dialog__content__upload--drag-over')"
    (dragenter)="$event.preventDefault(); uploadField.classList.add('change-avatar-dialog__content__upload--drag-over')"
    (dragleave)="
      $event.preventDefault(); uploadField.classList.remove('change-avatar-dialog__content__upload--drag-over')
    "
    (drop)="addFileToInput($event)"
    [ngClass]="{
      'change-avatar-dialog__content__upload--invalid': changeAvatarInput.invalid && changeAvatarInput.touched
    }"
  >
    <mat-icon class="change-avatar-dialog__content__upload-icon">file_upload</mat-icon>

    <p class="change-avatar-dialog__content__upload-title">
      {{ 'CHANGE_AVATAR.UPLOAD.TITLE' | translate }}
    </p>
    <p class="change-avatar-dialog__content__upload-description">
      <ng-container
        *ngIf="changeAvatarInput.hasError('size') || changeAvatarInput.hasError('required') || changeAvatarInput.valid"
      >
        {{ 'CHANGE_AVATAR.UPLOAD.DESCRIPTION' | translate }}
      </ng-container>

      <ng-container *ngIf="changeAvatarInput.hasError('extension')">
        {{ 'CHANGE_AVATAR.UPLOAD.EXTENSION_ERROR' | translate }}
      </ng-container>
    </p>
  </div>

  <div
    *ngIf="changeAvatarInput.valid"
    fxLayout="row"
    fxLayoutAlign="center center"
    class="change-avatar-dialog__content__cropper"
  >
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      (imageCropped)="imageCropped($event)"
      [maintainAspectRatio]="true"
      [aspectRatio]="1 / 1"
      [resizeToWidth]="128"
      [roundCropper]="true"
      format="png"
    ></image-cropper>
  </div>

  <div class="change-avatar-dialog__content__buttons">
    <button
      mat-raised-button
      class="change-avatar-dialog__content__buttons-button change-avatar-dialog__content__buttons-button--gray"
      [disabled]="changeAvatarInput.invalid || isLoading"
      (click)="fileInput.click()"
    >
      {{ 'CHANGE_AVATAR.SELECT_OTHER' | translate }}
    </button>

    <button
      mat-raised-button
      class="change-avatar-dialog__content__buttons-button"
      [disabled]="changeAvatarInput.invalid || isLoading"
      (click)="saveNewPicture()"
    >
      {{ 'CHANGE_AVATAR.SAVE' | translate }}
    </button>
  </div>
</div>
